import { Resources } from 'constants/resources';

import { useNavigateToRoot } from 'hooks/useNavigateToRoot';
import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { useEditWorkGroupAccess } from 'pages/Finance/WorkTeams/hooks/useEditWorkGroupAccess';
import { ReferralsDeleteDialog } from 'pages/Referrals/components/ReferralsDeleteDialog';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useShowController } from 'react-admin';
import { DeleteButton, EditLinkButton } from 'shared/mui/Buttons';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { DateTimeField, TextField } from 'shared/react-admin/Fields';
import { ShowPage } from 'shared/react-admin/Pages/ShowPage/ShowPage';
import { Permission } from 'types/embedded/permission';
import { WorkTeam } from 'types/embedded/workTeam';

export const ReferralsShow = (): JSX.Element => {
  const translate = useTypedTranslate();

  const { hasResourcePermissions } = usePermissions();
  const { record } = useShowController();
  const { toRoot } = useNavigateToRoot();

  const {
    handleOpenRecordModal: handleOpenRecordModalDelete,
    openRecordModal: openRecordModalDelete,
    handleCloseRecordModal: handleCloseRecordModalDelete,
  } = useRecordModal<WorkTeam>();

  const { hasEditWorkGroupAccess } = useEditWorkGroupAccess();

  return (
    <>
      <ShowPage
        listName={translate('app.referrals.title')}
        rightActionsSlot={[
          hasEditWorkGroupAccess(record) &&
            hasResourcePermissions(Resources.Referrals, [Permission.Full, Permission.Delete]) && (
              <DeleteButton onClick={() => handleOpenRecordModalDelete()} variant="outlined" />
            ),
          hasEditWorkGroupAccess(record) &&
            hasResourcePermissions(Resources.Referrals, [Permission.Full, Permission.Update]) && (
              <EditLinkButton variant="contained" />
            ),
        ]}
        title={translate('app.referrals.showTitle')}
      >
        <CardTable tableBodyProps={{ sx: { '& td': { width: '136px' } } }}>
          <TableRowWrapper label={translate('app.referrals.refId')}>
            <TextField source="refId" />
          </TableRowWrapper>
          <TableRowWrapper label={translate('app.table.name')}>
            <TextField source="name" />
          </TableRowWrapper>
          <TableRowWrapper label={translate('app.table.createdAt')}>
            <DateTimeField inline source="createdAt" />
          </TableRowWrapper>
          <TableRowWrapper label={translate('app.table.lastUpdatedAt')}>
            <DateTimeField inline source="updatedAt" />
          </TableRowWrapper>
        </CardTable>
      </ShowPage>
      {openRecordModalDelete && (
        <ReferralsDeleteDialog
          onClose={handleCloseRecordModalDelete}
          onSuccess={toRoot}
          open={openRecordModalDelete}
          record={record}
        />
      )}
    </>
  );
};
